export default __webpack_public_path__ + "static/media/i_bus-low_yl_tagless.22d5ca1b.svg";